<template>
  <div class="check-in-out">

    <div class="check-in-out__item">
      <Checkbox label="Early Check-In" v-model="isEarlyCheckIn"/>
      <TimeInput
          v-model="inputs.earlyCheckIn.time"
          label="Check-In Time"
          :disabled="!isEarlyCheckIn" />
      <BasicInput
          label="Increase price ($):"
          placeholder="-"
          v-model="inputs.earlyCheckIn.percent"
          type="number"
          :valueModifier="limitMinMaxInput"
          :disabled="!isEarlyCheckIn"
      />

    </div>

    <div class="check-in-out__item">
      <Checkbox label="Late Check-Out" v-model="isLateCheckOut"/>
      <TimeInput
          v-model="inputs.lateCheckOut.time"
          label="Check-Out Time"
          :disabled="!isLateCheckOut" />
      <BasicInput
          label="Increase price ($):"
          placeholder="-"
          v-model="inputs.lateCheckOut.percent"
          type="number"
          :valueModifier="limitMinMaxInput"
          :disabled="!isLateCheckOut"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "HotelCheckInOutTime",
  props: ['earlyCheckIn', 'lateCheckOut', 'inputsData'],
  data() {
    return {
      isEarlyCheckIn: this.earlyCheckIn,
      isLateCheckOut: this.lateCheckOut,
      inputs: JSON.parse(JSON.stringify(this.inputsData)),
    }
  },
  methods: {
    limitMinMaxInput(value) {
      if (+value <= 0) return '';
      return value;
    },
  },
  watch: {
    isEarlyCheckIn() {
      this.$emit('updateEarlyCheckIn', this.isEarlyCheckIn);
    },
    isLateCheckOut() {
      this.$emit('updateLateCheckOut', this.isLateCheckOut);
    },
    inputs: {
      handler() {
        this.$emit('updateInputsData', this.inputs)
      },
      deep: true,
    },
  }
}
</script>

<style scoped lang="scss">
.check-in-out {
  display: flex;
  flex-direction: column;
  margin: 2rem 0;
  width: 100%;

  &__item {
    display: flex;
    margin: 0.5rem 0;
    width: 100%;

    @media (max-width: 767px) {
      flex-wrap: wrap;
    }
  }
}
</style>